import React from "react";
import { useState } from "react";
import "../../styles/settings/trialShowcase.css";
import { useSelector, useDispatch } from "react-redux";
import PaystackPop from "@paystack/inline-js";
import { setUser } from "../../slice/webStoreUserSlice";
import { useNavigate } from "react-router-dom";
import { subscriptionURL } from "../../api/endpoints";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const TrialShowcase = ({ setIsLoading, socket }) => {
  const [subscriptionInitiated, setSubscriptionInitiated] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);
  // Mock trial dates - in real app these would come from props or API
  const trialStartDate = new Date(user.freeTrialStartDate);
  const trialEndDate = new Date(user.freeTrialEndDate);
  const currentDate = new Date();
  const daysRemaining = Math.ceil((trialEndDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
  const navigate = useNavigate();
  const popup = new PaystackPop();

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleUpgrade = async (tier) => {
    setSubscriptionInitiated(true);
    setIsLoading(true);
    const payload = tier;
    console.log(`Upgrading to ${tier.userType} tier`);
    // Here you would implement the actual upgrade logic
    uiAlert(
      "You are about to subscribe to " + tier.userType + " plan for " + tier.price.toLocaleString() + " " + tier.subscriptionRange + ". Click ok to continue"
    );
    let accessToken = localStorage.getItem("accessToken");
    console.log(tier);

    try {
      let response = await fetch(subscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        socket.emit("paymentCreated", user._id);
        let { accessCode } = await response.json();
        popup.resumeTransaction(accessCode, {
          onCancel: function () {
            setIsLoading(false);
          },
        });
        setIsLoading(true);
        // dispatch(setUser(data));
        // console.log("subscription updated", data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubscriptionInitiated(false);
      //  setIsLoading(false);
    }
  };
  const plans = [
    {
      id: "basic",
      name: "Basic",
      price: "8000",
      discountPrice: "4000",
      period: "per month",
      description: "For basic users and it includes:",
      popular: false,
      badge: "Saver",

      features: [
        "Create one store",
        "Business KPI tracking",
        "List only 60 products",
        "Free support",
        "Access our E-Commerce Hub",
        "Free hardware installation",
        "2% discount on extra services",
      ],
      plan: "Basic",
      planCode: "PLN_hahlu4ksdvaf2z7",
    },
    {
      id: "super",
      name: "Super",
      price: "17000",
      discountPrice: "8500",
      period: "per month",
      description: "For super users and it includes:",
      popular: true,
      badge: "Saver",

      features: [
        "Basic user Ad ons",
        "Create two stores",
        "Create one warehouse",
        "24 hours free Ad monthly",
        "List upto 200 products",
        "Free hardware installation",
        "10% discount on extra services",
        "Free personel training",
      ],
      plan: "Super",
      planCode: "PLN_zivia4d7pckqvsk",
    },
    {
      id: "premium",
      name: "Premium",
      price: "42500",
      discountPrice: "21250",
      period: "per month",
      description: "For premium users and it includes:",
      popular: false,
      badge: "Saver",

      features: [
        "Super user Ad ons",
        "Create upto 5 stores",
        "Create 3 warehouses",
        "50 hours free Ad monthly",
        "List up 700 products",
        "Free hardware installation",
        "30% discount on extra services",
        "Free personel training",
      ],
      plan: "Premium",
      planCode: "PLN_ju6xfjdjmvl0qoy",
    },
  ];

  return (
    <div className='trial-showcase'>
      <div className='trial-container'>
        {/* Trial Status Section */}
        <div className='trial-header'>
          <h1 className='trial-title privacy-data-info-title'>Free Trial Active</h1>
          {/*  <p className='trial-subtitle'>{daysRemaining > 0 ? `${daysRemaining} days remaining` : "Trial expired"}</p> */}
          <p className='trial-subtitle'>You are currently on free trial</p>
        </div>

        <div className='trial-dates'>
          <div className='date-item'>
            <div className='date-label'>Started</div>
            <div className='date-value'>{formatDate(trialStartDate)}</div>
          </div>
          <div className='date-item'>
            <div className='date-label'>Ends</div>
            <div className='date-value'>{formatDate(trialEndDate)}</div>
          </div>
        </div>

        {/* Upgrade Cards Section */}
        <div className='upgrade-section'>
          <h2 className='upgrade-title privacy-data-info-title'>Upgrade Your Plan</h2>
          <p className='upgrade-description'>Choose the perfect plan for your needs</p>
        </div>

        <div className='pricing-cards'>
          {/* Basic User Card */}
          <div className='pricing-card basic-card'>
            <div className='card-header'>
              <h3 className='card-title'>Basic User</h3>
              <div className='card-price'>
                {user?.userCountryCurrencySymbol}
                {plans[0].discountPrice?.toLocaleString()}
                <span style={{ textDecoration: "line-through", color: "#999", marginLeft: "5px", fontSize: "1.3rem" }}>{plans[0].price.toLocaleString()}</span>
              </div>
              <div className='card-period'>per month</div>
            </div>

            <ul className='card-features'>
              {plans[0].features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>

            <button
              className='upgrade-button basic-button'
              onClick={() =>
                handleUpgrade({
                  userType: "Basic",
                  price: plans[0].discountPrice,
                  subscriptionRange: "monthly",
                  plan_code: plans[0].planCode,
                })
              }
            >
              Choose Basic
            </button>
          </div>

          {/* Super User Card */}
          <div className='pricing-card super-card'>
            <div className='popular-badge'>Most Popular</div>
            <div className='card-header'>
              <h3 className='card-title'>Super User</h3>
              <div className='card-price'>
                {user?.userCountryCurrencySymbol}
                {plans[1].discountPrice.toLocaleString()}
                <span style={{ textDecoration: "line-through", color: "#999", marginLeft: "5px", fontSize: "1.3rem" }}>{plans[1].price.toLocaleString()}</span>
              </div>
              <div className='card-period'>per month</div>
            </div>

            <ul className='card-features'>
              {plans[1].features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>

            <button
              className='upgrade-button super-button'
              onClick={() => handleUpgrade({ userType: "Super", price: plans[1].discountPrice, subscriptionRange: "monthly", plan_code: plans[1].planCode })}
            >
              Choose Super
            </button>
          </div>

          {/* Premium User Card */}
          <div className='pricing-card premium-card'>
            <div className='card-header'>
              <h3 className='card-title'>Premium User</h3>
              <div className='card-price'>
                {user?.userCountryCurrencySymbol}
                {plans[2].discountPrice.toLocaleString()}
                <span style={{ textDecoration: "line-through", color: "#999", marginLeft: "5px", fontSize: "1.3rem" }}>{plans[2].price.toLocaleString()}</span>
              </div>
              <div className='card-period'>per month</div>
            </div>

            <ul className='card-features'>
              {plans[2].features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>

            <button
              className='upgrade-button premium-button'
              onClick={() =>
                handleUpgrade({
                  userType: "Premium",
                  price: plans[2].discountPrice,
                  subscriptionRange: "monthly",
                  plan_code: plans[2].planCode,
                })
              }
            >
              Choose Premium
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialShowcase;
